export default {"src":"/trader-new/_next/static/media/new_error_icon.d2912635.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};